import { tokens } from '@arvoreeducacao/bonsai-ds'
import styled from 'styled-components'

export const Wrapper = styled.div<{
  color: string
  isStoryTreeComunicarPath?: boolean
}>`
  height: 80dvh;
  background: ${({ color }) => color};
  padding: 29px 100vw 1px;
  margin: ${({ isStoryTreeComunicarPath }) =>
      isStoryTreeComunicarPath ? 0 : '99px'} -100vw -75dvh;
  border: 0;
  position: sticky;
  top: 0;
  z-index: -1;

  @media (max-width: ${tokens.breakpoints.tablet + 1}px) {
    padding: 29px 0 1px;
    margin: ${tokens.spacing.verticalLarge} 0 -78dvh;
  }

  @media (max-width: ${tokens.breakpoints.tabletSmall + 1}px) {
    margin: ${tokens.spacing.verticalXxxlarge} 0 -78dvh;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    transform: translateX(-50%);
    width: 100vw;
    height: 100%;
    background: inherit;
    z-index: -1;
  }
`
